import React from "react";
import { Route, Routes } from "react-router-dom";
import WarehouseManagerDashboard from "../../pages/dashboard/WarehouseManagerDashboard";
import WarehouseStockRequisition from "../../pages/StoresRequisition/WarehouseStockRequisition";
import NewWarehouseStockRequisition from "../../pages/StoresRequisition/NewWarehouseStockRequisition";
import WarehouseStockRequisitionDispatched from "../../pages/StoresRequisition/WarehouseStockRequisitionDispatched";
import RejectedRetailSupply from "../../pages/Inventory/warehouse/RejectedRetailSupply";
import NotFound404 from "../../pages/error/NotFound404";

const WarehouseManagerRoutes = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<WarehouseManagerDashboard />} />
      <Route
        path="/inventory/requisition"
        element={<WarehouseStockRequisition />}
      />
      <Route
        path="/inventory/requisition/dispatched"
        element={<WarehouseStockRequisitionDispatched />}
      />
      <Route
        path="/inventory/requisition/new"
        element={<NewWarehouseStockRequisition />}
      />
      <Route
        path="/inventory/requisition/retail/rejected"
        element={<RejectedRetailSupply />}
      />
      <Route path="/*" element={<NotFound404 />} />

    </Routes>
  );
};

export default WarehouseManagerRoutes;
